module.exports = __webpack_public_path__ + "img/how-to-flow-r-03.91343d43.svg";